import config from "config";
import { ContentLayoutType1 } from "pages/Product/ContentLayouts/ContentLayoutType1";
import {
  AssetArea,
  DescriptionArea,
  Image,
  SectionDescription,
  SectionSubTitle,
  SectionTitle,
  TitleArea,
} from "pages/Product/ContentLayouts/styled";
import { FeatureSectionWrapper } from "pages/Product/FeaturesSection/styled";
import React from "react";

export function Inquiry() {
  return (
    <FeatureSectionWrapper id="inquiries-or-leads">
      <ContentLayoutType1>
        <TitleArea>
          <SectionSubTitle>How can I manage</SectionSubTitle>
          <SectionTitle>Inquiries or leads?</SectionTitle>
        </TitleArea>
        <DescriptionArea>
          <SectionDescription>
            You can create your own contact form easily. Embed it to your
            website or publish it anywhere.
          </SectionDescription>
        </DescriptionArea>
        <AssetArea>
          <Image
            src={`${config.RESOURCE_ORIGIN}/images/landing/product/feature-inquiry.png`}
          />
        </AssetArea>
      </ContentLayoutType1>
    </FeatureSectionWrapper>
  );
}
